import PropTypes from 'prop-types'
import React from 'react'
import { formatMonth } from '../../../shared/utils'

export default function DateValue({ value }) {
  // return <span>{value.split('-').reverse().join('.')}</span>
  return <span>{formatMonth(value)}</span>
}

DateValue.propTypes = {
  value: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/frontend/shared/components/DateValue.js